<template lang="html">
  <div id="pets-home" class="row page">
    <div v-if="loader" class="loader"></div>
    <div class="col-lg-3"></div>
    <div class="col-lg-9">
      <div class="pets-container">
        <div class="row">
          <div class="col-md-3">
            <router-link to="/pets-registration">
              <div class="pet-info-container">
                <div class="add-pet-background">
                  <img class="img-responsive" src="../../assets/img/icons/add-pet-background-plus.svg" alt="Add background">
                </div>
                <div class="add-pet-text">
                  <div class="add-pet-icon">
                    <img class="img-responsive" src="../../assets/img/icons/add-pet-plus.svg" alt="Pluse">
                  </div>
                  <div class="add-pet">
                    <h3>{{translation.pets.addPet}}</h3>
                  </div>
                </div>
              </div>
            </router-link>
          </div>
          <div class="col-md-3" v-for="pet in pets">
            <div class="pet-info-container">
              <div class="pet-thumnail">
                <img class="img-responsive img-circle" v-if="pet.petThumb" :src="pet.petThumb">
                <img class="img-responsive img-circle" v-else src="../../assets/img/icons/empty-image-no-border.svg">
              </div>
              <div class="pet-name">
                <div class="pet-name">
                  <h3>{{pet.petName}}</h3>
                </div>
              </div>
              <div class="pet-passportId">
                <p>{{translation.petProfile.identNumber}}</p>
                {{pet.passportId}}
              </div>
              <div class="row text-center">
                <div class="pets-conteiner-footer">
                  <div class="col-md-6">
                    <router-link :key="pet.petId" :to="{name:'view-pet-profile', params:{ petId: pet.petId}}">
                      {{translation.pets.profile}}
                    </router-link>
                  </div>
                  <div class="col-md-6">
                    <router-link :key="pet.petId" :to="{name:'view-pet-reviews', params:{ petId: pet.petId}}">
                      {{translation.petReview.reviews}}
                    </router-link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12 text-center" v-if="pets.length == 0 ">
            <h3>{{translation.pets.noPets}}</h3>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data(){
    return{
      translation : null,
      pets:'',
      loader: false,
    }
  },
  created(){
    this.$bus.$on('language', () => {
      this.translation = window.message;
    });
    this.translation = window.message;
    window.pageHeader = this.translation.pets.pets;
    this.getPets();
    this.$bus.$on('createPet', () => {
      this.getPets();
    });
  },
  methods:{
    getPets: function(){
      this.loader = true;
      var self = this;
      axios.get('get-pets')
      .then(function (response){
          self.loader = false;
          self.pets = response.data.result
      })
      .catch(err => console.error(err))
    },
  }
}
</script>

<style>
#pets-home{

  background-image: url('../../assets/img/backgrounds/background-after-login.jpg');
  background-repeat:no-repeat;
  max-width:inherit;
  max-height: 100%;

  background-position: center;
  background-size: cover;
  min-height: 100vh;
}
#pets-home .pets-container{
  margin-top: 5em;
  margin-bottom: 10em;
}
#pets-home .add-pet-icon{
  width: 6em;
  display: inline-block;
  margin-bottom: 3em;
}

#pets-home .pet-info-container{
  height: 27em;
  background: #fff;
  -webkit-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  -moz-box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  box-shadow: 0 0 5px 10px rgba(168,168,168,.1);
  border-radius: .75em;
  position: relative;
  margin-bottom: 2em;
}
#pets-home .pets-conteiner-footer{
  width: 100%;
  position: absolute;
  bottom: 0;
  padding: .5em;
  text-align: center;
  display: inline-block;
  left: 0;
  background: #3057B0;
  color: #fff;
  font-weight: bold;
  border-bottom-left-radius: .75em;
  border-bottom-right-radius: .75em;
}
#pets-home .pets-conteiner-footer .col-md-6:first-of-type{
  border-right: 2px solid #fff;
}
#pets-home .pets-conteiner-footer a{
  color: #fff;
  font-weight: bold;
}
#pets-home .add-pet-background{
  padding-top: 5em;
}
#pets-home  .pet-thumnail{
  height: 50%;
  padding-top: 2em;
  border-top-left-radius: .75em;
  border-top-right-radius: .75em;
  background: linear-gradient(to bottom, #3057b0 50%, #fff 50%)
}
#pets-home  .pet-thumnail img{
  width: 10em;
  height: 10em;
  border: 4px solid #3057b0;
}
#pets-home  .pet-name{
  color: #3057b0
}
#pets-home .add-pet-text{
  position: absolute;
  top: 8em;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 1;
}
#pets-home  .add-pet h3 {
  color: #FE7154;
  text-transform: uppercase;
}
@media (max-width: 1024px) {
  #pets-home {
    margin-bottom: 9em;
  }
}
@media (max-width: 768px) {
  #pets-home .pets-conteiner-footer .col-md-6:first-of-type{
    border-right: none;
    border-bottom: 2px solid #fff;
  }
}
</style>
